import { useLingui } from '@lingui/react/macro';
import { ArrowRight2, MoreCircle } from 'iconsax-reactjs';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Link } from '@/base/router';
import { useSettings } from '@/settings/api';
import { cn } from '@/shared/react';
import { Button } from '../shared/Button';
import { useDocsIndex } from './useDocsIndex';

export const DocsSidebar: FC<{ activeSlug: string; className?: string }> = ({
  activeSlug,
  className,
}) => {
  const { t } = useLingui();
  const [{ language }] = useSettings();
  const entries = useDocsIndex('guide');

  const groups = useMemo(() => {
    const map = new Map<string, typeof entries>();
    for (const entry of entries) {
      const key = entry.section || t`More Guides`;
      map.set(key, [...(map.get(key) ?? []), entry]);
    }
    return [...map.entries()];
  }, [entries, t]);

  return (
    <nav
      aria-label={t`Other guides`}
      className={cn(
        'flex flex-col gap-widget border border-border-disabled rounded-xl px-3 py-3 h-fit sticky top-3',
        className,
      )}
    >
      <Link to={`/${language}/guide`} workspace="public" className="contents">
        <Button variant="outline" size={10} className="mb-3">
          <MoreCircle size={16} />
          {t`Browse all guides`}
        </Button>
      </Link>
      {groups.map(([section, items]) => (
        <div key={section} className="flex flex-col gap-0">
          <h2 className="text-xs uppercase text-content-tertiary tracking-wide px-3 flex gap-1 items-center">
            <ArrowRight2 className="auto-rtl" size={12} />
            {section}
          </h2>
          {items.map((item) => (
            <Link
              key={item.slug}
              to={`/${language}/${item.slug}`}
              workspace="public"
              className="contents"
            >
              <Button
                variant={item.slug === activeSlug ? 'link' : 'text'}
                size={10}
                className="block! text-start! truncate w-full ps-8 px-3 overflow-hidden"
                block
              >
                {item.title}
              </Button>
            </Link>
          ))}
        </div>
      ))}
    </nav>
  );
};
